import * as Yup from 'yup'

const AccessCodeSchema = Yup.object({
  code: Yup.string().label('Access Code').min(6).max(6).required(),
})

export type AccessCodeFormValues = Yup.InferType<typeof AccessCodeSchema>
export default AccessCodeSchema
